var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hl-info"},[_vm._v(" 检测项目意义解析 "),_c('i',{staticClass:"iconfont icon-right_medium"})])
}]

export { render, staticRenderFns }